import React from "react";

type MinutesDisplayProps = {
  minutes: number;
  color?: string;
  className?: string;
  size?: "sm" | "md" | "lg";
};

const MinutesDisplay: React.FC<MinutesDisplayProps> = ({
  minutes,
  color = "bg-bg-100 dark:bg-bg-100-dark",
  className = "",
  size = "md"
}) => {
  const sizeClasses = {
    sm: "text-xs px-1.5 py-0.5",
    md: "text-sm px-2 py-0.5",
    lg: "text-base px-2.5 py-1"
  };

  return (
    <div className={`${color} rounded-full ${sizeClasses[size]} ${className}`}>
      <span className="font-medium text-font-600 dark:text-font-600-dark">
        {minutes}&apos;
      </span>
    </div>
  );
};

export default MinutesDisplay;

